import { createApiAction } from '@app/packages/api/utils'
import type { ApiFeature } from '@app/packages/api/v2/types/entities'

export const getFeatures = () => createApiAction('getFeatures', dispatch => dispatch<{ data: ApiFeature[] }>({ method: 'GET', endpoint: '/api/v2/features' }))
